import { createDictionary } from './_base-dictionary'
export default createDictionary({
  resource: '/data/planlayouts',
  parseResponse: res => res.data
})
